import styled from 'styled-components';
import { asRem } from 'utils';
import { mediaQueries } from 'utils/Constants/Breakpoints';

export default styled.div`
  .sleep-sample-row {
    width: 100vw;
    overflow: visible;
    height: ${asRem(700)};

    ${mediaQueries.md} {
      height: ${asRem(370)};
    }

    ${mediaQueries.lg} {
      height: ${asRem(450)};
    }

    .content-wrapper {
      margin: -${asRem(40)} 0 0 0;
      text-align: left;
      padding: 0 ${asRem(30)} 0 ${asRem(30)};

      ${mediaQueries.md} {
        margin-top: 0;
        padding: 0;
      }

      ${mediaQueries.lg} {
        margin-top: ${asRem(80)};
      }

      .mime-elements-headline-2 {
        margin-bottom: ${asRem(8)};
      }
    }

    .mime-elements-paragraph {
      margin: 0;
    }
    .mime-elements-list {
      margin-left: 0;
    }

    .slider-image {
      height: ${asRem(380)};
      width: 100%;
      margin: -${asRem(30)} 0 ${asRem(20)} 0;

      background-size: contain;
      background-position: top center;

      ${mediaQueries.md} {
        background-position: center center;
        margin: -${asRem(50)} 0 0 0;
        height: ${asRem(380)};
      }

      ${mediaQueries.lg} {
        margin: -${asRem(20)} 0 0 0;
        height: ${asRem(450)};
        background-position: top right;
      }
    }
  }
`;
